export const Logo = ({ size = "md" }) => {
  const big = size === "lg";
  return (
    <span className="inline-grid grid-cols-[auto_auto] leading-none text-left" data-testid="brand-logo">
      <span className={`font-sans font-medium tracking-[-0.02em] text-neutral-100 ${big ? "text-5xl" : "text-[32px] sm:text-[36px]"}`}>
        Sanvalio
      </span>
      <span className={`font-sans font-medium text-gold ${big ? "text-5xl" : "text-[32px] sm:text-[36px]"}`}>.</span>
      <span
        className={`mt-1.5 flex justify-between font-sans font-light uppercase text-champagne/85 ${big ? "text-sm" : "text-[11px] sm:text-xs"}`}
        aria-label="Academy"
      >
        {"ACADEMY".split("").map((ch, i) => (
          <span key={i}>{ch}</span>
        ))}
      </span>
    </span>
  );
};
